/** Split compound strings into element symbols for filtering (e.g. "SiO2" → Si, O). */
export function splitCompoundIntoElements(compound: string): string[] {
  const elements: string[] = [];
  let currentElement = '';

  for (let i = 0; i < compound.length; i++) {
    const char = compound[i];
    const nextChar = compound[i + 1];

    if (char === char.toUpperCase()) {
      if (currentElement) {
        elements.push(currentElement);
      }
      currentElement = char;
      if (nextChar && nextChar === nextChar.toLowerCase()) {
        currentElement += nextChar;
        i++;
      }
    }
  }

  if (currentElement) {
    elements.push(currentElement);
  }

  return elements;
}
